import 'core-js/stable';
import 'regenerator-runtime/runtime';

import accordion from './modules/accordion';
import customSelect from './modules/customSelect';
import initFormModule from './modules/form';
import defaultSlider from './modules/defaultSlider';
import gallery from './modules/gallery';
import giraSlider from './modules/giraSlider';
import header from './modules/header';
import main from './modules/main';
import modal from './modules/modal';
import newsRelatedSlider from './modules/newsRelatedSlider';
import reviewSlider from './modules/reviewSlider';
import scrollAnimations from './modules/scrollAnimations';
import sideNav from './modules/sideNav';
import initializeTextChange from './modules/textChange';
import topLink from './modules/topLink';
import video from './modules/video';
import initA11yNavigation from './modules/a11yMenu';
import initTabSlider from './modules/tabSlider';

window.addEventListener('load', initA11yNavigation);
window.addEventListener('load', initializeTextChange);
window.addEventListener('load', sideNav);
window.addEventListener('load', giraSlider);
window.addEventListener('load', header);
window.addEventListener('load', accordion);
window.addEventListener('load', topLink);
window.addEventListener('load', scrollAnimations);
window.addEventListener('load', customSelect);
window.addEventListener('load', gallery);
window.addEventListener('load', video);
window.addEventListener('load', initFormModule);
window.addEventListener('load', modal);
window.addEventListener('load', defaultSlider);
window.addEventListener('load', reviewSlider);
window.addEventListener('load', newsRelatedSlider);
window.addEventListener('load', initTabSlider);
window.addEventListener('load', main);
